import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Button, Card, Input } from 'reactstrap';
import { push } from '../../utils/navigation';
import { BASE_URL } from '../../constants';
import {updatePassword, loadUsers} from '../../actions/userActions';
import _ from 'lodash-es';
import LayoutNoSidebar from '../../Layouts/LayoutNoSidebar';
import Spinner from '../Common/Spinner';
import PasswordStrengthInstruction from './PasswordStrengthInstruction';

const PasswordResetIndex = props => {
    const {dispatch, updatePassword, siteConfig} = props;
    const [passwordStrength, setPasswordStrength] = useState(3);
    const [pageLoading, setPageLoading] = useState(true);
    const[formData, setFormData] = useState({});
    const [saveLoading, setSaveLoading] = useState(false);

    useEffect(() => {
        validateUserAuthentication();
        setPasswordStrength(siteConfig && siteConfig.passwordStrength);
        setPageLoading(false);
    }, []);

    const validateUserAuthentication = () => {
        if(!siteConfig || !siteConfig.clientId){
            return dispatch(push(`${BASE_URL}/callback`));
          }
    };

    const handleSave = () => {
        if(!formData.currentPassword) return toastr.error("Current password is required.");
        if(!formData.newPassword) return toastr.error("New password is required.");
        if(!formData.confirmedNewPassword) return toastr.error("Confirm new password is required.");
        setSaveLoading(true);
        dispatch(updatePassword({payLoad: formData})).then(x => {
            setSaveLoading(false);
            if (!x || (!x.error && !( x.data && x.data.Message))) {
                toastr.success("Updated password.");
                dispatch(loadUsers()).then(x => {
                    dispatch(push(`${BASE_URL}/`));
                });
              }
        });
    };
    const handleFieldChange = ({value, field}) => {
        setFormData({...formData, [field]: value.currentTarget.value});
    };
    return(
        <LayoutNoSidebar siteConfig={siteConfig}>
            {
                pageLoading ?
                <Spinner />
                :
                <React.Fragment>
                <h4 style={{marginBottom: "24px"}}>Change Password</h4>
                <Card style={{padding: "20px", width: "100%", maxWidth: "600px", borderRadius: "6px"}}>
                    <div><label className="form-control-label"  htmlFor="name">Current Password</label></div>
                    <div>
                        <Input type="password"
                            value={formData.currentPassword}
                            onChange={e => handleFieldChange({value: e, field: "currentPassword"})}
                            name="currentPassword"
                            style={{marginBottom: "24px"}}
                        />
                    </div>
                    <div><label className="form-control-label"  htmlFor="name">New Password</label></div>
                    <div>
                        <Input type="password"
                            value={formData.newPassword}
                            onChange={e => handleFieldChange({value: e, field: "newPassword"})}
                            name="newPassword"
                            style={{marginBottom: "24px"}}
                        />
                    </div>
                    <div><label className="form-control-label"  htmlFor="name">Confirm Password</label></div>
                    <div>
                        <Input type="password"
                            value={formData.confirmedNewPassword}
                            onChange={e => handleFieldChange({value: e, field: "confirmedNewPassword"})}
                            name="confirmedNewPassword"
                            style={{marginBottom: "24px"}}
                        />
                    </div>
                    <PasswordStrengthInstruction passwordStrength={passwordStrength}/>   
                    <Button color="success"
                        onClick={e => handleSave()}
                        style={{width: "100%", fontWeight: "600", padding: "14px 0", cursor: "pointer"}}
                    >
                        SAVE & UPDATE
                    </Button>
                </Card>
            </React.Fragment>
            }
           </LayoutNoSidebar>
           
    );
};

function mapStateToProps(state){

    return {
        account: state.account,
        siteConfig: state.apiConfig
    };
}
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      updatePassword,
      loadUsers
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetIndex);